module.exports = __webpack_public_path__ + "static/media/c2_4.3e580ff0.png";